/**
 * configId je KLJUČ pod kojim biblioteka drži celo stanje jedne sesije u sessionStorage-u, i kad se ne
 * zada ona ga generiše POZICIONO kao `${index}-${clientId}`.
 *
 * ⚠️ Zato je ProTax-ov id zakucan na tačno onaj string koji je biblioteka do sada sama pravila. Bilo koja
 * druga vrednost bi na prvom deployu odjavila SVAKU živu sesiju — bez greške i bez vidljivog uzroka.
 * Iz istog razloga redosled niza u provideAuth prestaje da bude kozmetika.
 *
 * Asistentov configId više nije ovde — vlasnik mu je `@expertgroup/assistant`.
 */
export const PROTAX_CONFIG_ID = '0-ExpertGroup-protax-ui';
